import { usePostOrder } from '@api/pos/pos-transaction-api.rtk';
import { ConfirmationDialog } from '@hooks/useConfirmationDialog';
import { UseDisclosureInterface } from '@hooks/useDisclosure';
import useToast from '@hooks/useToast';
import {
  selectPOSstationID,
  selectPOSTableOrders,
  selectPOSTableTransactionID,
} from '@modules/point-of-sale/slice/pos-selector';
import { Button } from '@mui/material';
import { useAppSelector } from '@store/index';
import { selectPropertyID } from '@store/selector/property.selector';
import { buildPosOrderPayload } from '@utils/pos-utils';

const POSConfirmationDialog = ({
  dialogDisclosure,
  onConfirm,
  onClose,
  desc,
}: {
  dialogDisclosure: UseDisclosureInterface;
  onConfirm: () => Promise<void>;
  onClose?: () => void;
  desc?: string;
}) => {
  const { toast } = useToast();
  const transactionID = useAppSelector(selectPOSTableTransactionID);
  const propertyID = useAppSelector(selectPropertyID);
  const stationID = useAppSelector(selectPOSstationID);
  const orders = useAppSelector(selectPOSTableOrders);

  const [postOrder, { isLoading }] = usePostOrder();

  const handleSyncOrder = async () => {
    try {
      await postOrder({
        transactionID,
        payload: {
          properties: [
            {
              property: {
                propertyID,
                posOrders: buildPosOrderPayload({
                  orders:
                    orders?.filter(
                      (item) => !item.isPrintedOS && !item.orderID,
                    ) ?? [],
                  propertyID,
                  stationID,
                }),
              },
            },
          ],
        },
      }).unwrap();

      onConfirm?.();
    } catch (error) {
      toast({ message: error, severity: 'warning' });
    }
  };

  return (
    <ConfirmationDialog
      loading={isLoading}
      open={dialogDisclosure.isOpen}
      title='Confirmation'
      desc={
        desc ??
        'Are you sure you want to leave this page? Unsaved data will be lost.'
      }
      color='warning'
      iconColor='warning'
      onConfirm={onConfirm}
      onClose={() => {
        dialogDisclosure.onClose();
        onClose?.();
      }}
      backBtnProps={{ variant: 'outlined' }}
      confirmButtonTitle='Yes'
      cancelButtonTitle='No'
      additionalBtn={<Button onClick={handleSyncOrder}>Sync Order(s)</Button>}
    />
  );
};

export default POSConfirmationDialog;
